import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilityService } from '../../services/utility.service';
import { Router } from '@angular/router';
import { WebClientService } from '../../services/webclient-settings.service';
/**
 * VoucherComponent
 */
let VoucherComponent = class VoucherComponent {
    constructor(httpClient, sanitizer, themeService, checker, router, utilityService, webSettingsService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.checker = checker;
        this.router = router;
        this.utilityService = utilityService;
        this.webSettingsService = webSettingsService;
        this.userData = {};
        this.nameOfCurrency = 'btc';
        this.voucherData = {};
        this.cryptocurrencies = [];
        this.fieldsDisabled = true;
        this.displayMessage = false;
        this.returnData = {};
        this.validCode = false;
        this.valid = true;
        this.invalidVoucher = false;
        this.voucherMessage = '';
        this.successColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.secondColor = '';
        this.unregisteredUserData = {};
        this.invalidPhoneNumber = false;
        this.emailError = false;
        this.responseForPhoneValidation = {};
        this.smsSent = false;
        this.showSmsForm = false;
        this.token = '';
        this.isWrongSms = false;
        this.smsCodeValidated = false;
        this.validated = false;
        this.smsCodeError = false;
        this.sessionMobile = '';
        this.sessionEmail = '';
        this.errorForOrder = '';
        this.invalidPin = false;
        this.mobileValidated = false;
        this.mainColor = '';
        this.userType = '';
        this.validVoucher = false;
        this.voucherValue = '';
        this.cryptocurrencyAmount = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.bchAddressError = false;
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.sessionMobile = sessionStorage.getItem('mobile');
        this.sessionEmail = sessionStorage.getItem('email');
        if (this.sessionMobile !== 'null' && this.sessionMobile !== 'undefined') {
            this.unregisteredUserData.phone_number = this.sessionMobile;
        }
        if (this.sessionEmail !== 'undefined' && this.sessionEmail !== 'null') {
            this.unregisteredUserData.email_address = this.sessionEmail;
        }
    }
    ngOnInit() {
        let scrollStep = -window.scrollY / (300 / 15);
        let scrollInterval = setInterval(function () {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            }
            else
                clearInterval(scrollInterval);
        }, 15);
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.voucherData.cryptocurrency_code = '9999';
        if (typeof this.userData !== 'undefined' && this.userData !== null) {
            this.userType = this.userData.user_type_id.type;
            if (this.userData.validated !== 1) {
                this.fieldsDisabled = true;
            }
            if (this.userData.mobile_number_validated === 1) {
                this.mobileValidated = true;
            }
            this.unregisteredUserData.phone_number = this.userData.mobile;
            this.unregisteredUserData.email_address = this.userData.email;
            sessionStorage.setItem('email', this.userData.email);
            sessionStorage.setItem('mobile', this.userData.mobile);
        }
    }
    validateAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            this.nameOfCurrency = this.voucherData.cryptocurrency_code;
            const address = this.voucherData.deposit_address;
            const currency = this.nameOfCurrency.toUpperCase();
            if (this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
                yield this.utilityService.validateAddress(address, currency).then(result => {
                    this.valid = result.validDepositAddress;
                });
            }
            else {
                this.valid = true;
            }
            return this.valid;
        });
    }
    checkVoucher() {
        if (this.voucherData.voucher_code) {
            if (this.voucherData.voucher_code.length > 3) {
                this.httpClient.post('voucher/checkvouchercode', {
                    voucher_code: this.voucherData.voucher_code,
                    cryptocurrency_code: this.voucherData.cryptocurrency_code
                }).subscribe((data) => {
                    this.cryptocurrencies = data['wallet-cryptocurrencies'];
                    this.voucherData.cryptocurrency_code = this.cryptocurrencies[0].cryptocurrency_code;
                    this.voucherValue = data['voucher_value'];
                    this.cryptocurrencyAmount = this.cryptocurrencies[0].cryptocurrency_amount;
                    let s = '';
                    let temp;
                    let num = parseFloat(this.cryptocurrencyAmount + '').toString().split('.');
                    let n = num[0];
                    while (n.length > 3) {
                        temp = n.substring(n.length - 3);
                        s = '.' + temp + s;
                        n = n.slice(0, -3);
                    }
                    if (n) {
                        s = n + s;
                    }
                    if (num[1]) {
                        s += ',' + num[1].toString();
                    }
                    this.cryptocurrencyAmount = s;
                    let onlyPrice = this.voucherValue.split(' ')[0];
                    let onlyCurrency = this.voucherValue.split(' ')[1];
                    let s2 = '';
                    let temp2;
                    let num2 = parseFloat(onlyPrice.replace(/,/g, '') + '').toString().split('.');
                    let n2 = num2[0];
                    while (n2.length > 3) {
                        temp2 = n2.substring(n2.length - 3);
                        s2 = '.' + temp2 + s2;
                        n2 = n2.slice(0, -3);
                    }
                    if (n2) {
                        s2 = n2 + s2;
                    }
                    if (num2[1]) {
                        s2 += ',' + num2[1].toString();
                    }
                    this.voucherValue = s2 + ' ' + onlyCurrency;
                    this.invalidVoucher = false;
                    this.fieldsDisabled = false;
                    this.validCode = true;
                    this.validVoucher = true;
                }, (error) => {
                    this.invalidVoucher = true;
                    this.fieldsDisabled = true;
                    this.voucherMessage = error.error['message'];
                    this.validVoucher = false;
                    this.cryptocurrencyAmount = '';
                    this.voucherValue = '';
                });
            }
            else {
                this.invalidVoucher = true;
                this.fieldsDisabled = true;
                this.validCode = false;
                this.voucherMessage = 'INVALID_VOUCHER';
            }
        }
        else {
            this.invalidVoucher = true;
            this.fieldsDisabled = true;
            this.validCode = false;
        }
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateAddress();
            this.checkPin();
            this.sessionMobile = sessionStorage.getItem('mobile');
            this.sessionEmail = sessionStorage.getItem('email');
            if (this.valid && !this.invalidPin) {
                if (this.userData) {
                    this.httpClient.post('voucher/createorder', {
                        voucher_code: this.voucherData.voucher_code,
                        cryptocurrency_code: this.voucherData.cryptocurrency_code,
                        deposit_address: this.voucherData.deposit_address,
                        sms_token: this.userData.mobile_number_validated ? null : this.newSmsCode,
                        pin: this.voucherData.pin ? this.voucherData.pin : null,
                        mobile: this.userData.mobile_number_validated ? this.userData.mobile : this.sessionMobile,
                        email: this.userData.email
                    }).subscribe((data) => {
                        this.displayMessage = true;
                        this.returnData = data;
                        let s = '';
                        let temp;
                        let num = parseFloat(this.returnData.cryptocurrency_amount + '').toString().split('.');
                        let n = num[0];
                        while (n.length > 3) {
                            temp = n.substring(n.length - 3);
                            s = '.' + temp + s;
                            n = n.slice(0, -3);
                        }
                        if (n) {
                            s = n + s;
                        }
                        if (num[1]) {
                            s += ',' + num[1].toString();
                        }
                        this.returnData.cryptocurrency_amount = s;
                        this.returnData.value = this.returnData.cryptocurrency_amount + ' ' + this.returnData.cryptocurrency_code.toUpperCase();
                        sessionStorage.setItem('voucherData', this.returnData.value);
                        sessionStorage.setItem('voucherAddress', this.returnData.deposit_address);
                        this.router.navigateByUrl('voucher/success');
                    }, (error) => {
                        this.errorForOrder = error.error['message'];
                    });
                }
                else {
                    this.httpClient.post('voucher/createorder', {
                        voucher_code: this.voucherData.voucher_code,
                        cryptocurrency_code: this.voucherData.cryptocurrency_code,
                        deposit_address: this.voucherData.deposit_address,
                        sms_token: this.newSmsCode,
                        pin: this.voucherData.pin ? this.voucherData.pin : null,
                        mobile: (this.sessionMobile !== 'undefined' && this.sessionMobile !== 'null' && this.sessionMobile !== '') ? this.sessionMobile : null,
                        email: (this.sessionEmail !== 'undefined' && this.sessionEmail !== 'null' && this.sessionEmail !== '') ? this.sessionEmail : null
                    }).subscribe((data) => {
                        this.displayMessage = true;
                        this.returnData = data;
                        let s = '';
                        let temp;
                        let num = parseFloat(this.returnData.cryptocurrency_amount + '').toString().split('.');
                        let n = num[0];
                        while (n.length > 3) {
                            temp = n.substring(n.length - 3);
                            s = '.' + temp + s;
                            n = n.slice(0, -3);
                        }
                        if (n) {
                            s = n + s;
                        }
                        if (num[1]) {
                            s += ',' + num[1].toString();
                        }
                        this.returnData.cryptocurrency_amount = s;
                        this.returnData.value = this.returnData.cryptocurrency_amount + ' ' + this.returnData.cryptocurrency_code.toUpperCase();
                        sessionStorage.setItem('voucherData', this.returnData.value);
                        sessionStorage.setItem('voucherAddress', this.returnData.deposit_address);
                        this.router.navigateByUrl('voucher/success');
                    }, (error) => {
                        this.errorForOrder = error.error['message'];
                    });
                }
            }
        });
    }
    checkPin() {
        if (this.voucherData.pin) {
            this.invalidPin = false;
            const pin = this.voucherData.pin;
            const regEx = /[^0-9]/;
            const length = pin.length;
            if (length === 4) {
                for (let i = 0; i < length; i++) {
                    if (regEx.test(pin[i])) {
                        this.invalidPin = true;
                    }
                }
            }
            else if (length === 0) {
                this.invalidPin = false;
            }
            else {
                this.invalidPin = true;
            }
        }
    }
    checkPhone() {
        this.invalidPhoneNumber = !this.checker.checkPhone(this.unregisteredUserData.phone_number);
        return !this.invalidPhoneNumber;
    }
    checkEmail() {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        if (reg.test(this.unregisteredUserData.email_address) === false && this.unregisteredUserData.email_address) {
            this.emailError = true;
            return false;
        }
        else {
            this.emailError = false;
            return true;
        }
    }
    submitData() {
        this.checkEmail();
        this.checkPhone();
        if (!this.emailError &&
            !this.invalidPhoneNumber) {
            sessionStorage.setItem('email', this.unregisteredUserData.email_address);
            sessionStorage.setItem('mobile', this.unregisteredUserData.phone_number);
            this.httpClient.post('voucher/checkuserdata', {
                mobile: this.unregisteredUserData.phone_number,
                email: this.unregisteredUserData.email_address ? this.unregisteredUserData.email_address : null
            }).subscribe((data) => {
                this.showSmsForm = true;
                this.smsCodeError = false;
            }, (error) => {
                const errorMessage = error.error['message'];
                if (errorMessage === 'INVALID_MOBILE_NUMBER_FORMAT') {
                    this.invalidPhoneNumber = true;
                }
                else if (errorMessage === 'INVALID_EMAIL') {
                    this.emailError = true;
                }
            });
        }
    }
    sendSMS() {
        this.sessionMobile = sessionStorage.getItem('mobile');
        this.httpClient.post('voucher/sendtoken', {
            mobile: (this.sessionMobile !== 'null') ? this.sessionMobile : this.unregisteredUserData.phone_number
        }).subscribe((result) => {
            this.smsSent = true;
            this.smsCodeError = false;
        }, (error) => {
            this.smsCodeError = true;
        });
    }
    confirmSms() {
        this.httpClient.post('voucher/checktoken', {
            token: this.token
        }).subscribe((result) => {
            this.isWrongSms = false;
            this.smsCodeValidated = true;
            this.newSmsCode = result['token'];
        }, (error) => {
            this.isWrongSms = true;
        });
    }
    onChange(cryptocurrencyCode) {
        const cryptocurrency = this.cryptocurrencies.filter(function (item) {
            return item.cryptocurrency_code === cryptocurrencyCode;
        })[0];
        this.cryptocurrencyAmount = cryptocurrency.cryptocurrency_amount;
        let s = '';
        let temp;
        let num = parseFloat(this.cryptocurrencyAmount + '').toString().split('.');
        let n = num[0];
        while (n.length > 3) {
            temp = n.substring(n.length - 3);
            s = '.' + temp + s;
            n = n.slice(0, -3);
        }
        if (n) {
            s = n + s;
        }
        if (num[1]) {
            s += ',' + num[1].toString();
        }
        this.cryptocurrencyAmount = s;
    }
};
VoucherComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: UtilityService },
    { type: Router },
    { type: UtilityService },
    { type: WebClientService }
];
VoucherComponent = __decorate([
    Component({
        selector: 'ecd-voucher',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./voucher.component.html")).default
    })
], VoucherComponent);
export { VoucherComponent };
